<template>
    <div class="d-flex justify-content-between align-items-center action-container">
        <template v-if="actions.length > 0">
            <div v-for="action in actions"
                :key="action.key"
                :class="['btn-action', 'btn-action-' + action.options.theme]"
                @click="event(action, data)"
                :aria-label="getAriaLabel(action)">
                <i v-if="action.options.theme == 'warning'" class="material-icons button-icon">edit</i>
                <i v-if="action.options.theme == 'danger'" class="material-icons button-icon">delete</i>
                <i v-if="action.options.assets" class="material-icons button-icon">inventory_2</i>
                <span class="button-label">
                  <span v-if="action.options.theme == 'warning'">Editar</span>
                  <span v-else-if="action.options.theme == 'danger'">Remover</span>
                  <span v-else-if="action.options.assets">Assets</span>
                </span>
            </div>
        </template>
    </div>
</template>

<script>

import Action from '@/mixins/core/ActionBehavior'
import Event from '@/mixins/core/EventBehavior'

export default {
  mixins: [Action, Event],
  data: () => ({ actionsScope: 'Buttons' }),
  props: {
    data: { type: Object, required: false }
  },
  methods: {
    getAriaLabel (action) {
      if (action.options.theme === 'warning') return 'Editar item'
      if (action.options.theme === 'danger') return 'Remover item'
      if (action.options.assets) return 'Ver assets'
      return 'Ação'
    }
  }
}
</script>

<style lang="stylus" scoped>

    @import '../../style/colors.styl';
    @import '../../style/spacing.styl';

    .action-container
      background-color transparent
      padding space-sm 0

    .btn-action
      display flex
      align-items center
      gap space-xs
      padding space-sm space-md
      border-radius radius-md
      cursor pointer
      transition all transition-base
      border none
      font-weight 600
      font-size 0.9rem
      min-width 100px
      justify-content center
      box-shadow shadow-sm

      &:hover
        transform translateY(-2px)
        box-shadow shadow-md

      &:active
        transform translateY(0)

      .button-icon
        font-size 1.1rem
        margin 0

      .button-label
        white-space nowrap

    .btn-action-warning
      background linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%)
      color white

      &:hover
        background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
        box-shadow shadow-orange-lg

    .btn-action-danger
      background linear-gradient(135deg, danger 0%, darken(danger, 10%) 100%)
      color white

      &:hover
        background linear-gradient(135deg, darken(danger, 10%) 0%, darken(danger, 20%) 100%)
        box-shadow 0 4px 15px rgba(189, 27, 36, 0.3)

    .btn-action-success
      background linear-gradient(135deg, success 0%, darken(success, 10%) 100%)
      color white

      &:hover
        background linear-gradient(135deg, darken(success, 10%) 0%, darken(success, 20%) 100%)
        box-shadow 0 4px 15px rgba(45, 95, 71, 0.3)

    // Focus state for accessibility
    .btn-action:focus
      outline 2px solid primary
      outline-offset 2px

</style>
